// 模板业务服务
export class TemplateService {
  
  /**
   * 导入模板
   * @param {File} file - 模板文件
   * @returns {Promise<Object>} 模板数据
   */
  static async importTemplate(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const templateData = JSON.parse(e.target.result)
          
          // 验证模板数据结构
          if (!templateData.config || !templateData.elements) {
            throw new Error('模板文件格式不正确')
          }
          
          resolve(templateData)
        } catch (error) {
          reject(new Error('模板文件解析失败: ' + error.message))
        }
      }
      reader.onerror = () => reject(new Error('文件读取失败'))
      reader.readAsText(file)
    })
  }
  
  /**
   * 导出模板
   * @param {Object} templateConfig - 模板配置
   * @param {Array} elements - 模板元素
   * @returns {void}
   */
  static exportTemplate(templateConfig, elements) {
    const templateData = {
      config: templateConfig,
      elements: elements,
      version: '2.0',
      timestamp: new Date().toISOString(),
      metadata: {
        creator: 'PrintTemplateEditor',
        description: '打印模板配置文件'
      }
    }
    
    const blob = new Blob([JSON.stringify(templateData, null, 2)], { 
      type: 'application/json' 
    })
    
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `${templateConfig.name || '模板'}_${Date.now()}.json`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }
  
  /**
   * 验证模板配置
   * @param {Object} config - 模板配置
   * @returns {Object} 验证结果
   */
  static validateTemplate(config) {
    const errors = []
    const warnings = []
    
    // 基础验证
    if (!config.name || config.name.trim() === '') {
      errors.push('模板名称不能为空')
    }
    
    if (config.width <= 0 || config.height <= 0) {
      errors.push('纸张尺寸必须大于0')
    }
    
    if (config.marginTop < 0 || config.marginLeft < 0) {
      errors.push('边距不能为负数')
    }
    
    // 警告检查
    if (config.width > 500 || config.height > 500) {
      warnings.push('纸张尺寸过大，可能影响打印效果')
    }
    
    if (config.marginTop > config.height * 0.3 || config.marginLeft > config.width * 0.3) {
      warnings.push('边距过大，可能影响内容显示')
    }
    
    return {
      isValid: errors.length === 0,
      errors,
      warnings
    }
  }
  
  /**
   * 生成模板预览数据
   * @returns {Object} 预览数据
   */
  static generatePreviewData() {
    const mockData = {
      orderNumber: 'SO202310310001',
      customerName: '张三',
      orderTime: '2023-10-31 14:30:00',
      products: [
        { code: 'P001', name: '苹果', category: '水果', brand: '红富士', qty: 10 },
        { code: 'P002', name: '香蕉', category: '水果', brand: '进口', qty: 5 },
        { code: 'P003', name: '橙子', category: '水果', brand: '赣南', qty: 8 }
      ]
    }
    
    return mockData
  }
  
  /**
   * 计算元素布局
   * @param {Array} elements - 模板元素
   * @param {Object} canvasSize - 画布尺寸
   * @returns {Array} 布局后的元素
   */
  static calculateLayout(elements, canvasSize) {
    return elements.map(element => {
      // 确保元素在画布范围内
      const style = { ...element.style }
      
      const left = parseInt(style.left) || 0
      const top = parseInt(style.top) || 0
      const width = parseInt(style.width) || 100
      const height = parseInt(style.height) || 30
      
      // 边界检查
      if (left + width > canvasSize.width) {
        style.left = Math.max(0, canvasSize.width - width) + 'px'
      }
      
      if (top + height > canvasSize.height) {
        style.top = Math.max(0, canvasSize.height - height) + 'px'
      }
      
      return {
        ...element,
        style
      }
    })
  }
}
